import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Typography from '@classify/react-core-components/Typography';
import { styled } from '@classify/react-core-components/styles';
import ListItem from '@mui/material/ListItem';
interface Props {
  children: ReactNode;
}
const Item = styled(Typography)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  paddingTop: spacing(2),
  color: palette.text.onMainMinor
}));
const OverTitleListItem = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ListItem><Item variant="overline">{children}</Item></ListItem>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default OverTitleListItem;